import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ActivityContextMenuComponent } from './activity-context-menu.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		MatMenuModule,
		GoMaterialModule
	],
	declarations: [
		ActivityContextMenuComponent
	],
	exports: [
		ActivityContextMenuComponent
	],
	providers: [
		TranslatePipe
	]
})
export class ActivityContextMenuModule {}
